import { getToken } from "../../helper/common";
import agent from "../services/agent";
import {
    ADD_APP_VERSION,
    CLEAR_CREATE_APP_VERSION_ERROR,
    CLEAR_UPDATE_APP_VERSION_ERROR,
    CLOSE_CREATE_APP_VERSION_MODAL,
    CLOSE_UPDATE_APP_VERSION_MODAL,
    CREATE_APP_VERSION_ERROR,
    CREATE_APP_VERSION_PENDING,
    GET_APP_VERSION_PENDING,
    OPEN_CREATE_APP_VERSION_MODAL,
    OPEN_UPDATE_APP_VERSION_MODAL,
    APP_VERSION_LIST_ERROR,
    SET_APP_VERSION_LIST,
    SET_APP_VERSION_DETAILS,
    UPDATE_APP_VERSION_ERROR,
    UPDATE_APP_VERSION_PENDING,
    CLEAR_APP_VERSION_LIST_ERROR,
    SET_APP_VERSION_EDIT_FORM
} from "./constants";
import { showSnackbarStatus } from "../snackbar/actions";
import { clearForm } from "../form/actions";
import trimmedValues from "../../helper/trimmer";

//--------------------------------APP-VERSION-LIST------------------------------------------------
export const getAppVersionPending = () => ({
    type: GET_APP_VERSION_PENDING,
});

export const appVersionListError = (errorMessage) => ({
    type: APP_VERSION_LIST_ERROR,
    payload: { errorMessage },
});

export const clearAppVersionListError = () => ({
    type: CLEAR_APP_VERSION_LIST_ERROR,
});

const setAppVersionList = (appVersionOdata) => ({
    type: SET_APP_VERSION_LIST,
    payload: { appVersionOdata },
});

export const getAppVersionList = (page, currentPage, searchVersionNo, searchNotes, searchReleasedDate, searchCreatedBy, searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder) => (dispatch) => {
    dispatch(getAppVersionPending());
    getToken(dispatch).then((accessToken) => {
        agent.AppVersion.getAppVersionList(accessToken, page, currentPage, searchVersionNo, searchNotes, searchReleasedDate, searchCreatedBy, searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder)
            .then((appVersionList) => {
                dispatch(setAppVersionList(appVersionList));
            })
            .catch((err) => {
                console.log("getAppVersionList server error", err);
                if (err && err.response) {
                    const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
                    dispatch(appVersionListError(message));
                    return;
                }
                else {
                    const message = "Network error";
                    dispatch(appVersionListError(message));
                }
                dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
            });
    });
};

//--------------------------------APP-VERSION-CREATE----------------------------------------------
export const openCreateAppVersionModal = () => ({
    type: OPEN_CREATE_APP_VERSION_MODAL,
});

export const closeCreateAppVersionModal = () => ({
    type: CLOSE_CREATE_APP_VERSION_MODAL,
});

export const addAppVersion = (addAppVersionForm) => ({
    type: ADD_APP_VERSION,
    payload: { addAppVersionForm },
});

export const createAppVersionPending = () => ({
    type: CREATE_APP_VERSION_PENDING,
});

export const createAppVersionError = (errorMessage) => ({
    type: CREATE_APP_VERSION_ERROR,
    payload: { errorMessage },
});

export const clearCreateAppVersionError = () => ({
    type: CLEAR_CREATE_APP_VERSION_ERROR,
});

export const appVersionCreate = (AddAppVersion) => (dispatch) => {
    const values = trimmedValues(AddAppVersion);
    dispatch(createAppVersionPending());
    getToken(dispatch).then((accessToken) => {
        agent.AppVersion.appVersionCreate(accessToken, values)
            .then(() => {
                dispatch(clearCreateAppVersionError());
                dispatch(clearForm());
                dispatch(closeCreateAppVersionModal());
                dispatch(getAppVersionList());
                dispatch(showSnackbarStatus("App version created successfully"));
            })
            .catch((err) => {
                if (err && err.response) {
                    const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
                    console.log("message: ", message);
                    dispatch(createAppVersionError(message));
                    return;
                }
                else {
                    const message = "Network error";
                    dispatch(createAppVersionError(message));
                }
                console.log("createAppVersion server error", err);
                dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
            });
    });
};

//--------------------------------APP-VERSION-EDIT------------------------------------------------
export const setAppVersionDetails = (appVersionDetails) => ({
    type: SET_APP_VERSION_DETAILS,
    payload: { appVersionDetails },
});

export const openUpdateAppVersionModal = () => ({
    type: OPEN_UPDATE_APP_VERSION_MODAL,
});

export const closeUpdateAppVersionModal = () => ({
    type: CLOSE_UPDATE_APP_VERSION_MODAL,
});

export const setEditAppVersionForm = (appVersionForm) => ({
    type: SET_APP_VERSION_EDIT_FORM,
    payload: { appVersionForm },
});

export const updateAppVersionPending = () => ({
    type: UPDATE_APP_VERSION_PENDING,
});

export const updateAppVersionError = (errorMessage) => ({
    type: UPDATE_APP_VERSION_ERROR,
    payload: { errorMessage },
});

export const clearUpdateAppVersionError = () => ({
    type: CLEAR_UPDATE_APP_VERSION_ERROR,
});

export const appVersionEdit = (data) => (dispatch) => {
    const values = trimmedValues(data);
    dispatch(updateAppVersionPending());
    getToken(dispatch).then((accessToken) => {
        agent.AppVersion.appVersionEdit(accessToken, values)
            .then(() => {
                dispatch(clearUpdateAppVersionError());
                dispatch(clearForm());
                dispatch(closeUpdateAppVersionModal());
                dispatch(getAppVersionList());
                dispatch(showSnackbarStatus("App version updated successfully"));
            })
            .catch((err) => {
                if (err && err.response) {
                    const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
                    dispatch(updateAppVersionError(message));
                    return;
                }
                else {
                    const message = "Network error";
                    dispatch(updateAppVersionError(message));
                }
                console.log("updateAppVersion server error", err);
                dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
            });
    });
};